import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";


export enum SideNavigationState {
  Hidden,
  HalfClosed,
  Open
}

@Injectable({
  providedIn: 'root'
})
export class SideNavigationService {
  private sideNavigationState: BehaviorSubject<SideNavigationState> = new BehaviorSubject<SideNavigationState>(SideNavigationState.HalfClosed);
  public sideNavigationState$: Observable<SideNavigationState> = this.sideNavigationState.asObservable();

  constructor() {}

  setSideNavState(state: SideNavigationState) {
    this.sideNavigationState.next(state);
  }


  //
  // openSideNav(){
  //   this.sideNavigationIsOpen.next(true);
  // }
  //
  // closeSideNav(){
  //   this.sideNavigationIsOpen.next(false);
  // }
  //
  // toggleSideNav(){
  //   this.sideNavigationIsOpen.next(!this.sideNavigationIsOpen.value);
  // }
  //
  // setSideNavAsDialog(isDialog: boolean){
  //   this.sideNavigationIsDialog.next(isDialog);
  // }

}
